import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginForm from '../../components/loginForm/loginForm';
import './landingPage.scss';
import { Col, Container, Row } from 'react-bootstrap';
import logo from '../../logo.png';
import { useSelector, useDispatch } from 'react-redux';
import logoutAction from '../../actions/login/logoutAction';
import vertexLogo from '../../assets/vertexLogo.png';
import poweredBy from '../../assets/poweredBy.png';
import clearDataAction from '../../actions/pages/clearDataAction';

const LandingPage = (props) => {
  const hasCleanedLogin = useRef(null);
  const authData = useSelector((state) => state.authData);
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!hasCleanedLogin.current && authData.isAuthUser) {
      dispatch(logoutAction());
      dispatch(clearDataAction());
    }

    hasCleanedLogin.current = true;
  }, [dispatch, authData]);

  return (
    <Container fluid className="landing-page">
      <Row className="justify-content-sm-end">
        <Col sm="auto">
          <span className="header-title" >Referral Portal</span>
        </Col>
        <Col sm="auto">
          <img src={logo} alt=""></img>
        </Col>
      </Row>
      <Row className="row justify-content-sm-center">
        <Col className="landing-ctn" sm="auto">
          <LoginForm props={props} />
        </Col>
      </Row>
      <div className="footer-logo">
      <img src={poweredBy} alt=""></img>
      <img src={vertexLogo} alt=""></img>
      </div>
    </Container>
  );
};

export default LandingPage;
